<template>
    <div>
        <div class="row">
            <div class="col-sm-3 border-right">
                <table class="table">
                    <thead>
                    <tr>
                        <th colspan="2">Series</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td colspan="2">
                            <input type="text"
                                   class="form-control"
                                   placeholder="Search..."
                                   v-on:input="asyncSeriesQuery"
                                   v-model="query.series">
                        </td>
                    </tr>
                    <tr v-if="loadingSeries">
                        <td colspan="2" class="text-center">Loading...</td>
                    </tr>
                    <tr v-for="s in series.data"
                        @click="selectSeries(s)"
                        :class="s == selectedSeries ? 'table-active' : ''">
                        <td width="30px">
                            <input type="checkbox"
                                   @click="(e) => checkSeries(e, s.id)"
                                   :id="'series-' + s.id"
                                   :checked="seriesIds.indexOf(s.id) >= 0 ? 'checked' : ''"/>
                        </td>
                        <td>
                            <label>
                                {{ s.name }} <span class="badge badge-default">{{ s.events_count }}</span>
                            </label>
                        </td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                        <td colspan="2">
                            <pagination :data="series" @pagination-change-page="asyncSeriesQuery"></pagination>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </div>
            <div class="col">
                <table class="table" ref="eventsTable">
                    <thead>
                    <tr>
                        <th colspan="2">Event</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td colspan="2">
                            <input type="text"
                                   class="form-control"
                                   placeholder="Search..."
                                   v-on:input="asyncEventsQuery"
                                   v-model="query.event">
                        </td>
                    </tr>
                    <tr v-if="loadingSeries">
                        <td colspan="2" class="text-center">Loading...</td>
                    </tr>
                    <tr v-if="loadingEvents === false && clickedSerie !== null"
                        v-for="e in events.data">
                        <td width="30px">
                            <input type="checkbox"
                                   @click="(clickEvent) => checkEvent(clickEvent, e.id)"
                                   :id="'event-' + e.id"
                                   :checked="eventIds.indexOf(e.id) >= 0 ? 'checked' : ''"/>
                        </td>
                        <td><label :for="'event-' + e.id">{{ e.title }}</label></td>
                    </tr>
                    </tbody>
                    <tfoot v-show="loadingSeries === false && clickedSerie !== null">
                    <tr>
                        <td colspan="2">
                            <pagination :data="events" @pagination-change-page="asyncEventsQuery"></pagination>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
        <input type="hidden" :name="inputNameSeries + '[]'" v-for="sId in seriesIds" :value="sId">
        <input type="hidden" :name="inputNameEvents + '[]'" v-for="eId in eventIds" :value="eId">
    </div>
</template>
<script>
import axios from 'axios';
import qs from "qs";

export default {
    name: 'PartnerEventSelectorInput',
    props: {
        inputNameSeries: {
            required: true,
            type: String
        },
        inputNameEvents: {
            required: true,
            type: String
        },
        inputSeriesIds: {
            required: true,
            type: Array
        },
        inputEventIds: {
            required: true,
            type: Array
        }
    },
    mounted() {
        this.seriesIds = this.inputSeriesIds;
        this.eventIds = this.inputEventIds;
        this.asyncSeriesQuery();
    },
    updated() {
        if (this.selectedSeries &&
                this.seriesIds.indexOf(this.selectedSeries.id) >= 0
        ) {
            this.setIndeterminateStatus(true);
        }
    },
    data: () => {
        return {
            query: {
                series: null,
                event: null
            },
            series: {},
            events: {},
            seriesIds: [],
            eventIds: [],
            selectedSeries: null,
            clickedSerie: null,
            loadingSeries: false,
            loadingEvents: false,
            cancellationTokenSources: {
                fetchSeries: axios.CancelToken.source(),
                fetchEvents: axios.CancelToken.source()
            }
        };
    },
    methods: {
        checkSeries(e, id) {
            let inSet = this.seriesIds.indexOf(id) >= 0;

            if (e.target.checked && !inSet) {
                this.eventIds = [];
                this.seriesIds.push(id);
            }

            if (!e.target.checked && inSet) {
                this.seriesIds.splice(this.seriesIds.indexOf(id), 1);
                this.eventIds = [];
                this.setIndeterminateStatus(false);
            }
        },
        async checkEvent(e, id) {
            let inSet = this.eventIds.indexOf(id) >= 0;

            this.setIndeterminateStatus(false);
            if (this.seriesIds.indexOf(this.selectedSeries.id) >= 0) {
                this.seriesIds.splice(this.seriesIds.indexOf(this.selectedSeries.id), 1);
                await this.getEventIdsForSeries(this.selectedSeries.id).then((eventIds) => {
                    this.eventIds.push(...eventIds);
                });
            }

            if (e.target.checked && !inSet) {
                this.eventIds.push(id);
            }

            if (!e.target.checked && inSet) {
                this.eventIds.splice(this.eventIds.indexOf(id), 1);
            }
        },
        selectSeries(series) {
            if (this.selectedSeries === series) {
                return;
            }

            this.selectedSeries = series;
            this.events = {};
            this.clickedSerie = series.id;
            this.asyncEventsQuery();
        },

        asyncSeriesQuery(page = 1){
            this.cancelFetchEvents();
            this.cancelFetchSeries();
            this.deselectSeries();

            this.series = {};
            this.loadingSeries = true;

            this.fetchSeries(page);
        },

        async getEventIdsForSeries(seriesId) {
            let eventIds = [];
            await axios.get(`/admin/api/series/${seriesId}/event-ids`)
                    .then((response) => {
                        eventIds = response.data;
                    })
                    .catch((e) => {
                        if (axios.isCancel(e)) {
                            eventIds = [];
                        }
                    });

            return eventIds;
        },

        fetchSeries: _.debounce(function(page = 1) {
            let params = {};

            if (this.query.series) {
                params['filters[query]'] = this.query.series;
            }

            axios
                    .get('/admin/api/series?page=' + page + '&perPage=15', {
                        params,
                        cancelToken: this.cancellationTokenSources.fetchSeries.token
                    })
                    .then((response) => {
                        this.loadingSeries = false;
                        this.series = response.data;
                    })
                    .catch((e) => {
                        if (axios.isCancel(e)) {
                            return;
                        }
                        this.loadingSeries = false;
                    });
        }, 500),

        asyncEventsQuery(page = 1) {
            this.cancelFetchEvents();
            this.loadingEvents = true;

            this.fetchEvents(this.query.event, page);
        },

        fetchEvents: _.debounce(function (queryString, page) {
            const stringifiedQueryString = qs.stringify({
                filters: {
                    query: queryString,
                    seriesId: this.clickedSerie
                }
            });

            axios
                    .get(`/admin/api/events?page=${page}&perPage=15&${stringifiedQueryString}`, {
                        cancelToken: this.cancellationTokenSources.fetchEvents.token
                    })
                    .then((response) => {
                        this.loadingEvents = false;
                        this.events = response.data;
                    })
                    .catch((e) => {
                        if (axios.isCancel(e)) {
                            return;
                        }
                        this.loadingEvents = false;
                    });
        }, 500),
        deselectSeries() {
            this.clickedSerie = null;
        },
        setIndeterminateStatus(status) {
            let inputs = this.$refs['eventsTable']
                    .getElementsByTagName('input');

            let checkboxes = _.filter(inputs, input => input.type === 'checkbox');

            _.each(checkboxes, function (checkbox) {
                checkbox.indeterminate = status;
            });
        },
        cancelFetchSeries() {
            this.cancellationTokenSources.fetchSeries.cancel();
            this.cancellationTokenSources.fetchSeries = axios.CancelToken.source();
        },
        cancelFetchEvents() {
            this.cancellationTokenSources.fetchEvents.cancel();
            this.cancellationTokenSources.fetchEvents = axios.CancelToken.source();
        }
    }
};
</script>
